// extracted by mini-css-extract-plugin
export default {"main":"Main_main__i7J6Z","section":"Main_section__B21fF"};